<script>import Google from "./google.svelte";
import WalletConnect from "./wallet-connect.svelte";
import { Theme, wantThemes } from "@infinitro/config";
</script>

<div class="section">
	<Google />
	{#if wantThemes([Theme.Flush])}
		<WalletConnect />
	{/if}
</div>

<style>
	.section {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0.5rem
}
</style>
